import { createContext, useReducer } from "react";

//#region  ----------- initialStates ---------------
import atencionSinTurnoInitialState from "./initialState/atencionSinTurno";
import avisoAutocheckInitialState from "./initialState/avisoAutocheckInitialState";
import demoraInitialState from "./initialState/demoraInitialState";
import filaVirtualInitialState from "./initialState/filaVirtualInitialState";
import medicoPorMatriculaInitialState from "./initialState/medicoPorMatriculaInitialState";
import ordenInitialState from "./initialState/ordenInitialState";
import pasoInitialState from "./initialState/pasoInitialState";
import presenteInitialState from "./initialState/presenteInitialState";
import puntoControlInitialState from "./initialState/puntoControlInitialState";
import rutaInitialState from "./initialState/rutaInitialState ";
import textosAutoCheckInitialState from "./initialState/textosAutoCheckInitialState";
import turnosAutoCheckInitialState from "./initialState/turnosAutoCheckIn";
import turnosRecepcionadosInitialState from "./initialState/turnosRecepcionadosInitialState";
import turnosSeleccionadosInitialState from "./initialState/turnosSeleccionadosInitialState";
import ubicacionInitialState from "./initialState/ubicacionInitialState";
//#endregion --------- initialStates ---------------

//#region  ----------- reducers ---------------
import atencionSinTurno from "./reducers/atencionSinTurno";
import avisoAutocheck from "./reducers/avisoAutocheck";
import demora from "./reducers/demora";
import filaVirtual from "./reducers/filaVirtual";
import medicoPorMatricula from "./reducers/medicoPorMatricula";
import orden from "./reducers/orden";
import paso from "./reducers/paso";
import presente from "./reducers/presente";
import puntoControl from "./reducers/puntoControl";
import ruta from "./reducers/ruta";
import textosAutoCheckin from "./reducers/textosAutoCheckin";
import turnosAutoCheckIn from "./reducers/turnosAutoChekIn";
import turnosRecepcionados from "./reducers/turnosRecepcionados";
import turnosSeleccionados from "./reducers/turnosSeleccionados";
import ubicacion from "./reducers/ubicacion";
import laboratorio from "./reducers/laboratorio";
import laboratorioInitialState from "./initialState/labotario";
import turnoSaldado from "_+_Portal/context/reducers/turnoSaldado";
import turnoSaldadoInitialState from "_+_Portal/context/initialStates/turnoSaldadoInitialState";
//#endregion --------- reducers ---------------

export const AutocheckContext = createContext();

const AutocheckinProvider = ({ children }) => {
  const [atencionSinTurnoState, atencionSinTurnoDispatch] = useReducer(
    atencionSinTurno,
    atencionSinTurnoInitialState
  );
  const [avisoAutocheckState, avisoAutocheckDispatch] = useReducer(
    avisoAutocheck,
    avisoAutocheckInitialState
  );
  const [demoraState, demoraDispatch] = useReducer(demora, demoraInitialState);
  const [filaVirtualState, filaVirtualDispatch] = useReducer(
    filaVirtual,
    filaVirtualInitialState
  );
  const [medicoPorMatriculaState, medicoPorMatriculaDispatch] = useReducer(
    medicoPorMatricula,
    medicoPorMatriculaInitialState
  );
  const [textosAutoCheckinState, textosAutoCheckinDispatch] = useReducer(
    textosAutoCheckin,
    textosAutoCheckInitialState
  );
  const [ordenState, ordenDispatch] = useReducer(orden, ordenInitialState);
  const [pasoState, pasoDispatch] = useReducer(paso, pasoInitialState);
  const [presenteState, presenteDispatch] = useReducer(
    presente,
    presenteInitialState
  );
  const [puntoControlState, puntoControlDispatch] = useReducer(
    puntoControl,
    puntoControlInitialState
  );
  const [rutaState, rutaDispatch] = useReducer(ruta, rutaInitialState);
  const [turnosAutoCheckInState, turnosAutoCheckInDispatch] = useReducer(
    turnosAutoCheckIn,
    turnosAutoCheckInitialState
  );
  const [turnosRecepcionadosState, turnosRecepcionadosDispatch] = useReducer(
    turnosRecepcionados,
    turnosRecepcionadosInitialState
  );
  const [turnosSeleccionadosState, turnosSeleccionadosDispatch] = useReducer(
    turnosSeleccionados,
    turnosSeleccionadosInitialState
  );
  const [turnoSaldadoState, turnoSaldadoDispatch] = useReducer(
    turnoSaldado,
    turnoSaldadoInitialState
  );
  const [ubicacionState, ubicacionDispatch] = useReducer(
    ubicacion,
    ubicacionInitialState
  );
  const [laboratorioState, laboratorioDispatch] = useReducer(
    laboratorio,
    laboratorioInitialState
  );

  return (
    <AutocheckContext.Provider
      value={{
        atencionSinTurnoState,
        atencionSinTurnoDispatch,
        avisoAutocheckState,
        avisoAutocheckDispatch,
        demoraState,
        demoraDispatch,
        filaVirtualState,
        filaVirtualDispatch,
        textosAutoCheckinState,
        textosAutoCheckinDispatch,
        pasoState,
        pasoDispatch,
        presenteState,
        presenteDispatch,
        puntoControlState,
        puntoControlDispatch,
        turnosAutoCheckInState,
        turnosAutoCheckInDispatch,
        turnosRecepcionadosState,
        turnosRecepcionadosDispatch,
        turnosSeleccionadosState,
        turnosSeleccionadosDispatch,
        rutaState,
        rutaDispatch,
        medicoPorMatriculaState,
        medicoPorMatriculaDispatch,
        ordenState,
        ordenDispatch,
        ubicacionState,
        ubicacionDispatch,
        laboratorioState,
        laboratorioDispatch,
        turnoSaldadoState,
        turnoSaldadoDispatch,
      }}
    >
      {children}
    </AutocheckContext.Provider>
  );
};

export default AutocheckinProvider;
